module.exports = "<template>\n   \n\t\t\t<router-view>\n\t\t\t</router-view>\n\n</template>";